import { render } from "./TotalOrdersChart.vue?vue&type=template&id=4055f57d&ts=true"
import script from "./TotalOrdersChart.vue?vue&type=script&lang=ts"
export * from "./TotalOrdersChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__